import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './News.css';

const API_URL = process.env.REACT_APP_API_URL;

export default function News() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    fetch(`${API_URL}/api/news`)
      .then(res => res.json())
      .then(data => {
        // Sort articles by date descending
        const sortedArticles = data.sort((a, b) => new Date(b.date) - new Date(a.date));
        setArticles(sortedArticles);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    document.title = 'News';
  }, []);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <div className="page-banner" style={{ backgroundImage: 'url(/news_banner.png)' }}>
        <h1 className="page-banner-title" id="news-heading">
          News
        </h1>
      </div>
      <section className="news-page-wrapper" aria-labelledby="news-heading">
        {loading && <p>Loading...</p>}
        {!loading && articles.length === 0 && <p>No news articles found.</p>}
        <div className="results-grid">
          {articles.map(article => {
            // Debugging DELETE
            const imgSrc = article.image && article.image.startsWith('/uploads') ? `${API_URL}${article.image}` : article.image;
            console.log('Article:', article.title, 'Image field:', article.image, 'Computed src:', imgSrc);
            return (
              <div className="result-tile" key={article.id}>
                {article.image && (
                  <img
                    src={imgSrc}
                    alt={article.title}
                    className="news-article-image"
                  />
                )}
                <h3>{article.title}</h3>
                <span>{article.date}</span>
                <p dangerouslySetInnerHTML={{ __html: article.excerpt }} />
                <button onClick={() => navigate(`/news/${article.id}`)}>Read More</button>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
} 